"use client"

import { useEffect, useState } from "react"
import Link from "next/link"

import { getHotKeywordsAction } from "@/app/actions/hot-keyword"

export function MobileHotKeywords() {
  const [keywords, setKeywords] = useState<string[]>([])

  useEffect(() => {
    const fetchKeywords = async () => {
      try {
        const data = await getHotKeywordsAction()
        setKeywords(data?.keywords || [])
      } catch (error) {
        console.error("Failed to fetch hot keywords:", error)
      }
    }

    fetchKeywords()
  }, [])

  if (keywords.length === 0) {
    return null
  }

  return (
    <nav aria-label="Tìm kiếm phổ biến">
      <ul className="flex flex-wrap gap-2">
        {keywords.map((keyword) => (
          <li key={keyword}>
            <Link
              href={`/search?keyword=${encodeURIComponent(keyword)}&type=dish`}
              className="px-3 py-1 bg-gray-100 rounded-full text-sm inline-block hover:bg-gray-200"
              rel="search"
            >
              {keyword}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}
